import { jwtDecode } from "jwt-decode";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { HiOutlineShare } from "react-icons/hi";
import axios from "axios";
import { useTheme } from "../../components/Theme/Themecontext";
import { useTranslation } from "react-i18next";
import MeetingCard from "../../AtomicComponent/MeetingCard";
import { ReactComponent as Time } from "../../images/SvgCollection/Time.svg";
import { useAlertViewStore } from "../../common/store";
import Loader from "../../common/Loader";
import { ReactComponent as PDF } from "../../images/SvgCollection/greenpdf.svg";
import LoadingButton from "../../components/LoadingButton";

const MeetingDetails = () => {
  const { t, i18n } = useTranslation();

  // Move baseUrl outside of component or memoize it
  const baseUrl =
    process.env.NODE_ENV === "development"
      ? process.env.REACT_APP_BASE_URL_DEV
      : process.env.REACT_APP_BASE_URL_PROD;

  const { styles } = useTheme();
  const { component, blacktext, interior } = styles;
  const { showMsg } = useAlertViewStore();
  const location = useLocation();
  const navigate = useNavigate();
  const { meetingId } = useParams();

  const queryParams = new URLSearchParams(location.search);
  const queryMeetingId = queryParams.get("meetingId");
  const id = meetingId || queryMeetingId;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [options, setOptions] = useState([]);
  const [withinTenMinutes, setWithinTenMinutes] = useState(false);
  const [isOpen, setIsopen] = useState(false);
  const [isCancel, setIsCancel] = useState(false);

  const token = localStorage.getItem("Mandoobee-token");;
  const userInfo = token ? jwtDecode(token) : null;
  const userID = userInfo?.userId;

  const fetchTasks = async () => {
    try {
      const token = localStorage.getItem("Mandoobee-token");;
      try {
        const response = await fetch(`${baseUrl}/meeting/getById/${id}`, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();
          setOptions(data.result, "meetig");

          const now = new Date();
          const meetingStartTime = new Date(data.result.from);
          const timeDifference = (meetingStartTime - now) / 60000;

          if (timeDifference <= 10) {
            setWithinTenMinutes(true);
          }
          setLoading(false);
        } else {
          throw new Error("Failed to fetch meeting details");
        }
      } catch (fetchError) {
        console.error("Fetch error:", fetchError);
        setError(fetchError.message);
        setLoading(false);
      }
    } catch (outerError) {
      console.error("Error in fetchTasks:", outerError);
      setError(outerError.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTasks();
  }, [id, baseUrl]);

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    const formattedDateTime = date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return formattedDateTime;
  };


  const handleCancelMeeting = async () => {
    setIsCancel(true);
    try {
      const response = await fetch(
        `${baseUrl}/meeting/cancelMeeting/${options.meetingId}`,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to cancel meeting");
      }
      const data = await response.json();

      if (data?.isSuccess) {
        showMsg("Meeting cancelled successfully", "success", 3);
        setTimeout(() => {
          navigate("/home/meeting");
        }, 3000);
      } else {
        throw new Error("Failed to cancel the meeting");
      }
    } catch (error) {
      console.error("Error cancelling meeting:", error);
      showMsg("Error cancelling meeting", "error", 3);
    } finally {
      setIsCancel(false);
    }
  };

  const handleParticipation = (value) => {
    if (!token || !userInfo) {
      showMsg("User not authenticated", "error", 3);
      return;
    }

    const formData = {
      meetingId: id,
      participation: value,
    };

    axios
      .post(`${baseUrl}/meeting/meetingParticipation`, formData, {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("Response:", response.data);
        showMsg("Participation Successfully Updated", "success", 3);
        setTimeout(() => {
          navigate("/home/meeting");
        }, 1000);
      })
      .catch((error) => {
        console.error("Error adding asset:", error);
        showMsg("Error in updating participants", "error", 3);
      });
  };

  const handleShare = (link, username) => {
    if (navigator.share) {
      navigator
        .share({
          text: `Hi Team,\n
Hope you're having a great day. I just wanted to remind you about our Gmeeting later this ${
            options?.meetingDate
          } at ${formatTime(options?.from)} at ${
            options?.location
          } to discuss ${options?.desc}.\n\n
Please click the button below to join the meeting:\n${link}\n
Looking forward to seeing you soon,\n
${username}`,
        })
        .then(() => console.log("Shared successfully"))
        .catch((error) => console.error("Error sharing:", error));
    } else {
      alert("Sharing is not supported on this browser.");
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center w-full h-full">
        {error}
      </div>
    );
  }

  return (
    <>
      <div
        className={`w-full h-auto ${
          i18n.language === "ar" ? "text-right" : "text-left"
        } ${i18n.language === "ar" ? "rtl" : "ltr"}`}
        dir={i18n.language === "ar" ? "rtl" : "ltr"}
      >
        <div style={component} className="md:p-3 rounded-lg md:rounded-2xl">
          <div onClick={() => setIsopen(!isOpen)}>
            <MeetingCard meetingInfos={options} styleKey="component" />
          </div>

          <div className="px-2">
            <div style={component}>
              <h1 style={blacktext} className={`text-[14px] md:text-[16px]`}>
                {t("projectname")} :{options.projectName}
              </h1>
              <p style={blacktext} className="my-2 text-[14px] md:text-[16px]">
                {t("agenda")}
              </p>
              <p className="text-[14px] md:text-[16px]">{options?.desc}</p>
            </div>
          </div>

          <div
            className={`fixed bottom-16 flex flex-col items-end ${
              i18n.language === "ar"
                ? "left-2 md:left-5 rotate-180"
                : "right-2 md:right-5"
            }`}
          >
            <button
              onClick={() => handleShare(options?.link, options?.username)}
              className="bg-[#1552B2] text-white p-4 rounded-full shadow-lg flex items-center justify-center"
            >
              <HiOutlineShare className="text-[14px] md:text-[16px]" />
            </button>
          </div>
        </div>

        {!withinTenMinutes &&  (
          <div
            style={component}
            className="my-2 p-2 md:p-5 rounded-lg md:rounded-2xl"
          >
            <div className="grid grid-cols-3 lg:grid-cols-8 gap-2 mt-3">
              <div
                style={interior}
                className="h-[30px] flex items-center justify-center gap-1 border border-[#39AA54] rounded-xl cursor-pointer"
                onClick={() => handleParticipation(1)}
              >
                <Time style={{ color: "#39AA54" }} />
                <p className="text-[12px] md:text-[14px] font-medium">
                  {t("yes")}
                </p>
              </div>

              <div
                style={interior}
                className="h-[30px] flex items-center justify-center gap-1 border border-[#FF6C3B] rounded-xl cursor-pointer"
                onClick={() => handleParticipation(3)}
              >
                <Time style={{ color: "#FF6C3B" }} />
                <p className="text-[12px] md:text-[14px] font-medium">
                  {t("mayBe")}
                </p>
              </div>

              <div
                style={interior}
                className="h-[30px] flex items-center justify-center gap-1 border border-[#F95555] rounded-xl cursor-pointer"
                onClick={() => handleParticipation(2)}
              >
                <Time style={{ color: "#F95555" }} />
                <p className="text-[12px] md:text-[14px] font-medium">
                  {t("no")}
                </p>
              </div>
            </div>
          </div>
        )}

        {/* For MOM */}
        <div className="md:flex mt-3 gap-4">
          {!options?.momCreated &&  (
            <Link to={`/home/add_mom/create_mom?Id=${id}`}>
              <button
                type="button"
                className="w-full md:w-[150px] bg-[#1552B2] text-[#fff] p-2 rounded-lg text-[14px] md:text-[16px]"
              >
                {t("createmom")}
              </button>
            </Link>
          )}
          {(options.createUserId === userID && !withinTenMinutes ) && (
            <div className="md:flex items-center gap-4 my-3 md:mt-0">
              <LoadingButton
                onClick={handleCancelMeeting}
                loading={isCancel}
                className="md:w-[200px] w-full bg-[#1552B2] text-white"
              >
                {t("cancelmeet")}
              </LoadingButton>
              <Link to={`/home/meeting/view/editmeeting/${id}`}>
                <button
                  type="button"
                  className="w-full md:w-[150px] mt-3 bg-[#1552b2] text-white p-2 rounded-lg md:mt-0 text-[14px] md:text-[16px]"
                >
                  {t("edit")}
                </button>
              </Link>
            </div>
          )}
        </div>

        {isOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div style={component} className="w-[400px] p-3 rounded-lg">
              <div className="flex items-center justify-between">
                <h2 className="text-[14px] md:text-[16px] font-bold">
                  {t("attendees")}
                </h2>
                <button
                  type="button"
                  onClick={() => setIsopen(false)}
                  className="bg-[#e8eaed] flex items-center justify-center w-[20px] h-[20px] rounded-full focus:outline-none"
                >
                  <span
                    style={{ fontSize: "16px" }}
                    className="text-[#252525] material-symbols-outlined"
                  >
                    close
                  </span>
                </button>
              </div>
              <div className="mt-2 h-[400px] overflow-y-auto">
                {options.attendees?.map((item, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between mb-3"
                  >
                    <div className="flex items-center gap-2">
                      <img
                        src={item.userImage}
                        alt="host"
                        className="w-[30px] rounded-full"
                      />
                      <div>
                        <h1 className="text-[14px] lg:[16px]">
                          {item.userName}
                        </h1>
                        <p className="text-[12px] lg:[14px]">
                          {item?.userId === options.createUserId
                            ? "organizer"
                            : "participants"}
                        </p>
                      </div>
                    </div>
                    <div>
                      {item.attendeesStatus && (
                        <div className="flex items-center gap-2">
                          <div
                            className={`w-auto h-[20px] px-2 py-2 flex items-center justify-center rounded-[20px]`}
                          >
                            <p className="text-[8px] md:text-[10px]">
                              {item.attendeesStatus === 3 ? (
                                <div className="flex rounded-full p-1 items-center gap-2">
                                  <svg
                                    width="10"
                                    height="11"
                                    viewBox="0 0 10 11"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.99992 1.3335C2.70409 1.3335 0.833252 3.20433 0.833252 5.50016C0.833252 7.796 2.70409 9.66683 4.99992 9.66683C7.29575 9.66683 9.16659 7.796 9.16659 5.50016C9.16659 3.20433 7.29575 1.3335 4.99992 1.3335ZM6.81242 6.98766C6.75409 7.08766 6.64992 7.14183 6.54159 7.14183C6.48742 7.14183 6.43325 7.12933 6.38325 7.096L5.09159 6.32516C4.77075 6.1335 4.53325 5.71266 4.53325 5.34183V3.6335C4.53325 3.46266 4.67492 3.321 4.84575 3.321C5.01659 3.321 5.15825 3.46266 5.15825 3.6335V5.34183C5.15825 5.49183 5.28325 5.71266 5.41242 5.78766L6.70409 6.5585C6.85409 6.646 6.90409 6.83766 6.81242 6.98766Z"
                                      fill="#FF6C3B"
                                    />
                                  </svg>
                                  <span className="text-[10px]">maybe</span>
                                </div>
                              ) : item.attendeesStatus === 2 ? (
                                <div className="flex border rounded-full p-1 items-center gap-2">
                                  <svg
                                    width="10"
                                    height="11"
                                    viewBox="0 0 10 11"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.99992 1.3335C2.70409 1.3335 0.833252 3.20433 0.833252 5.50016C0.833252 7.796 2.70409 9.66683 4.99992 9.66683C7.29575 9.66683 9.16659 7.796 9.16659 5.50016C9.16659 3.20433 7.29575 1.3335 4.99992 1.3335ZM6.81242 6.98766C6.75409 7.08766 6.64992 7.14183 6.54159 7.14183C6.48742 7.14183 6.43325 7.12933 6.38325 7.096L5.09159 6.32516C4.77075 6.1335 4.53325 5.71266 4.53325 5.34183V3.6335C4.53325 3.46266 4.67492 3.321 4.84575 3.321C5.01659 3.321 5.15825 3.46266 5.15825 3.6335V5.34183C5.15825 5.49183 5.28325 5.71266 5.41242 5.78766L6.70409 6.5585C6.85409 6.646 6.90409 6.83766 6.81242 6.98766Z"
                                      fill="#F95555"
                                    />
                                  </svg>
                                  <span className="text-[10px]">No</span>
                                </div>
                              ) : item.attendeesStatus === 1 ? (
                                <div className="flex border rounded-full p-1 items-center gap-2">
                                  <svg
                                    width="10"
                                    height="11"
                                    viewBox="0 0 10 11"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.99992 1.3335C2.70409 1.3335 0.833252 3.20433 0.833252 5.50016C0.833252 7.796 2.70409 9.66683 4.99992 9.66683C7.29575 9.66683 9.16659 7.796 9.16659 5.50016C9.16659 3.20433 7.29575 1.3335 4.99992 1.3335ZM6.81242 6.98766C6.75409 7.08766 6.64992 7.14183 6.54159 7.14183C6.48742 7.14183 6.43325 7.12933 6.38325 7.096L5.09159 6.32516C4.77075 6.1335 4.53325 5.71266 4.53325 5.34183V3.6335C4.53325 3.46266 4.67492 3.321 4.84575 3.321C5.01659 3.321 5.15825 3.46266 5.15825 3.6335V5.34183C5.15825 5.49183 5.28325 5.71266 5.41242 5.78766L6.70409 6.5585C6.85409 6.646 6.90409 6.83766 6.81242 6.98766Z"
                                      fill="#39AA54"
                                    />
                                  </svg>
                                  <span className="text-[10px]">yes</span>
                                </div>
                              ) : (
                                <div className="flex border rounded-full p-1 items-center gap-2">
                                  <svg
                                    width="10"
                                    height="11"
                                    viewBox="0 0 10 11"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M4.99992 1.3335C2.70409 1.3335 0.833252 3.20433 0.833252 5.50016C0.833252 7.796 2.70409 9.66683 4.99992 9.66683C7.29575 9.66683 9.16659 7.796 9.16659 5.50016C9.16659 3.20433 7.29575 1.3335 4.99992 1.3335ZM6.81242 6.98766C6.75409 7.08766 6.64992 7.14183 6.54159 7.14183C6.48742 7.14183 6.43325 7.12933 6.38325 7.096L5.09159 6.32516C4.77075 6.1335 4.53325 5.71266 4.53325 5.34183V3.6335C4.53325 3.46266 4.67492 3.321 4.84575 3.321C5.01659 3.321 5.15825 3.46266 5.15825 3.6335V5.34183C5.15825 5.49183 5.28325 5.71266 5.41242 5.78766L6.70409 6.5585C6.85409 6.646 6.90409 6.83766 6.81242 6.98766Z"
                                      fill="yellow"
                                    />
                                  </svg>
                                  <span className="text-[10px]">pending</span>
                                </div>
                              )}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {options?.momLink && (
          <div
            style={component}
            className="flex  items-center gap-3 px-3 py-4 rounded-lg"
          >
            <PDF />
            <a className="text-[12px] md:text-[14px]" href={options?.momLink}>
              document
            </a>
          </div>
        )}
      </div>
    </>
  );
};

export default MeetingDetails;
